import Link from 'next/link';
import { useRouter } from 'next/router';
import { twMerge } from 'tailwind-merge';
import { env } from '@zopauk/nextjs-env';
import { logEvent } from '@/utils/analytics';
import Events from '@/utils/amplitudeEvents.json';
import { isBusinessRoute } from '@/utils/business-route';

type Segment = {
  label: string;
  href: string;
};

const segments: Segment[] = [
  { label: 'Personal', href: '/' },
  { label: 'Business', href: '/business' },
];

export const SiteSwitcher = () => {
  const router = useRouter();
  const isBusiness = isBusinessRoute(router.asPath);

  if (env('NEXT_PUBLIC_B2B_ENABLED') !== 'enabled' && !router.isPreview) {
    return null;
  }

  return (
    <nav
      className="flex w-full items-center gap-2 bg-base-content px-5 py-3 lg:px-[100px]"
      data-automation="ZA.site-switcher"
      aria-label="Site switcher"
    >
      {segments.map((segment) => {
        const isActive = segment.href === '/business' ? isBusiness : !isBusiness;

        return (
          <Link
            className={twMerge(
              'rounded-[30px] px-6 py-3 text-sm font-semibold leading-normal tracking-tight text-base-100 no-underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tertiary focus-visible:ring-offset-1 focus-visible:ring-offset-secondary',
              isActive ? 'bg-secondary' : '',
            )}
            onClick={() => {
              logEvent(Events.B2B_SITE_SWITCHER_CLICK, {
                destination: segment.href === '/business' ? 'b2b' : 'personal',
                user_type: isBusiness ? 'b2b' : 'personal',
              });
            }}
            data-automation={`ZA.site-switcher.${segment.label.toLowerCase()}`}
            aria-current={isActive ? 'page' : undefined}
            href={segment.href}
            key={segment.href}
          >
            {segment.label}
          </Link>
        );
      })}
    </nav>
  );
};
